import { requireVisitorCheckinContext } from '../VisitorCheckinContext'
import styles from './method-chooser.module.css'

export const MethodChooser = () => {
    const checkin = requireVisitorCheckinContext();
    return (
        <div class={styles['chooser']}>
            <button type="button" class={styles['tile']} onClick={() => checkin.setEntryMode('scan')}>
                <i class={`fas fa-id-card ${styles['glyph']}`} aria-hidden="true"></i>
                <span class={styles['label']}>Scan ID</span>
            </button>
            <button type="button" class={styles['tile']} onClick={() => checkin.setEntryMode('manual')}>
                <i class={`fas fa-keyboard ${styles['glyph']}`} aria-hidden="true"></i>
                <span class={styles['label']}>Manual Entry</span>
            </button>
        </div>
    );
};
